/**
 * YouTube/Vimeo embed renderer via iframe
 */

import { Box, Stack, Text } from '@mantine/core';
import { getEmbedUrl } from '../../../utils';

interface VideoEmbedRendererProps {
  externalUrl: string;
  title: string;
}

export function VideoEmbedRenderer({ externalUrl, title }: VideoEmbedRendererProps) {
  const embedUrl = getEmbedUrl(externalUrl);

  if (!embedUrl) {
    return (
      <Stack align="center" justify="center" h="100%">
        <Text c="white" size="lg">Unable to embed this video</Text>
        <Text c="dimmed" size="sm">{externalUrl}</Text>
      </Stack>
    );
  }

  return (
    <Box
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
      }}
    >
      <Box
        style={{
          width: '100%',
          maxWidth: '90vw',
          aspectRatio: '16 / 9',
          maxHeight: '80vh',
        }}
      >
        <iframe
          src={embedUrl}
          title={title}
          allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
          allowFullScreen
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            borderRadius: 8,
          }}
        />
      </Box>
    </Box>
  );
}
